import { createToastInterface } from 'vue-toastification';
import Toast from '@/lego/components/toasts/Toast.vue';
import ToastClose from '@/lego/components/toasts/ToastClose.vue';

const pluginOptions = {
  position: 'top-right',
  closeOnClick: false,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  draggable: false,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  icon: true,
  rtl: false,
  maxToasts: 5,
  newestOnTop: false,
};

const toastInterface = createToastInterface(pluginOptions);

export function displayToast(type, content) {
  const data = {
    component: Toast,
    closeButton: true,
    timeout: false,
    ...content,
  };

  toastInterface[type](data);
}

const customIconPluginOptions = {
  position: 'top-right',
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  draggable: false,
  draggablePercent: 0.6,
  closeButton: ToastClose,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  icon: false,
  rtl: false,
  maxToasts: 5,
  newestOnTop: false,
};

const customIconToastInterface = createToastInterface(customIconPluginOptions);

export function displayCustomIconToast(type, content) {
  const data = {
    component: Toast,
    closeButton: true,
    ...content,
  };

  customIconToastInterface[type](data);
}

export function clearToasts() {
  toastInterface.clear();
  customIconToastInterface.clear();
}
